import { inject, Service } from "@angular/core";

import { ProjectStatus } from "../constants/enums";
import {
  AgmDashboardResponse,
  AgmProject,
  EntityModelType,
  MainResponseModel,
  TpDashboardFilter,
  YearResponseModel,
} from "../models";
import { MainService } from "./main-service";

@Service()
export class AgmProjectApiService {
  private _mainService = inject(MainService);

  public deleteProject(id: number) {
    const url = `annual-meeting-project/deleteById/${id}`;

    return this._mainService.sendRequest<MainResponseModel>({
      method: "DELETE",
      url,
    });
  }

  public getProject(id: number) {
    const url = `annual-meeting-project/getById/${id}`;

    return this._mainService.sendRequest<MainResponseModel<AgmProject>>({
      method: "GET",
      url,
    });
  }

  public getProjectDashboard(id: number) {
    const url = `annual-meeting-project/values/${id}`;

    return this._mainService.sendRequest<MainResponseModel<AgmProject>>({
      method: "GET",
      url,
    });
  }

  public saveProject(data: AgmProject, isFinish: boolean) {
    let url = data.id ? "annual-meeting-project/update" : "annual-meeting-project/create";
    url += `?isFinish=${isFinish}`;

    const method = data.id ? "PUT" : "POST";

    return this._mainService.sendRequest<MainResponseModel<number>>({
      method,
      url,
      data,
    });
  }

  public getAgmDashboard(filter: TpDashboardFilter) {
    const url = `annual-meeting-project/values`;

    const qs = new URLSearchParams();
    if (filter.year) qs.append("year", filter.year.toString());
    if (filter.cycleId) qs.append("cycleId", filter.cycleId.toString());
    if (filter.entityId) qs.append("entityId", filter.entityId.toString());
    if (filter.sectorId) qs.append("nationalSector", filter.sectorId.toString());
    if (filter.mainSectorId) qs.append("mainNationalSector", filter.mainSectorId.toString());
    if (filter.ownerId) filter.ownerId.forEach((e) => qs.append("ownerId", e.toString()));
    if (filter.onlyProjectsOwnedByEntity) qs.append("useOwnerEntity", "true");

    if (filter.status === ProjectStatus.COMPLETED) {
      qs.append("status", "COMPLETED");
      qs.append("sortKey", "progress");
      qs.append("sortDirection", "desc");
      qs.append("groupedSort", "true");
    } else if (filter.status === ProjectStatus.ON_TIME) {
      qs.append("status", "ON_GOING");
      qs.append("sortKey", "progress");
      qs.append("sortDirection", "desc");
      qs.append("groupedSort", "true");
    } else if (filter.status === ProjectStatus.DELAYED) {
      qs.append("status", "DELAYED");
      qs.append("sortKey", "progress");
      qs.append("sortDirection", "desc");
      qs.append("groupedSort", "true");
    } else if (filter.status === ProjectStatus.MOST_COMPLETED) {
      qs.append("status", "COMPLETED");
      qs.append("status", "ON_GOING");
      qs.append("sortKey", "progress");
      qs.append("sortDirection", "desc");
      qs.append("groupedSort", "false");
    } else if (filter.status === ProjectStatus.MOST_DELAYED) {
      qs.append("status", "DELAYED");
      qs.append("sortKey", "progress");
      qs.append("sortDirection", "asc");
      qs.append("groupedSort", "false");
    } else if (filter.status === ProjectStatus.BEST_VISION) {
      qs.append("sortKey", "visionScore");
      qs.append("sortDirection", "desc");
      qs.append("groupedSort", "false");
      qs.append("visionLowLimit", "65.00000001");
      qs.append("visionHighLimit", "100");
    } else if (filter.status === ProjectStatus.LOWEST_VISION) {
      qs.append("sortKey", "visionScore");
      qs.append("sortDirection", "asc");
      qs.append("groupedSort", "false");
      qs.append("visionLowLimit", "0");
      qs.append("visionHighLimit", "65.00000001");
    }

    return this._mainService.sendRequest<MainResponseModel<AgmDashboardResponse>>({
      method: "GET",
      url: `${url}?${qs.toString()}`,
    });
  }

  public getProjectEntities() {
    const url = `annual-meeting-project/entities`;

    return this._mainService.sendRequest<MainResponseModel<EntityModelType[]>>({
      method: "GET",
      url,
    });
  }

  public getProjectYears() {
    const url = `national-project/years`;

    return this._mainService.sendRequest<MainResponseModel<YearResponseModel>>({
      method: "GET",
      url,
    });
  }
}
